import * as R from "ramda";

import { Heading } from "../Heading";

import styles from "./FormHeading.module.scss";

export const FormHeading = R.ifElse(
  R.prop("title"),
  ({ title, ...restProps }) => (
    <Heading className={styles.heading} {...restProps}>
      {title}
    </Heading>
  ),
  () => null
);
